import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useLangstonMediaGet = (contentId) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/content-document/${contentId}/media/`;
  return useRestQuery(requestUrl, { skip: !contentId });
};

export default useLangstonMediaGet;
